export default __webpack_public_path__ + "static/favicon-bbf17874324bb5c1836bf085d2129a0a.png";